export const calculateMortgageSummary = ({
  propertyPrice,
  depositMode,
  depositInput,
  interestRate,
  termYears,
}) => {
  const monthlyRate = interestRate / 100 / 12;
  const numberOfPayments = termYears * 12;
  const price = Number.isFinite(propertyPrice) ? propertyPrice : 0;
  const rawDeposit =
    depositMode === 'percent'
      ? price * ((Number.isFinite(depositInput) ? depositInput : 0) / 100)
      : (Number.isFinite(depositInput) ? depositInput : 0);
  const depositAmount = Math.min(Math.max(rawDeposit, 0), price);
  const depositPercent = price ? (depositAmount / price) * 100 : 0;
  const principal = Math.max(price - depositAmount, 0);

  let monthlyPayment = 0;
  if (principal > 0 && numberOfPayments > 0) {
    if (monthlyRate === 0) {
      monthlyPayment = principal / numberOfPayments;
    } else {
      monthlyPayment =
        (principal * monthlyRate) / (1 - Math.pow(1 + monthlyRate, -numberOfPayments));
    }
  }

  const totalPayment = monthlyPayment * numberOfPayments;
  const totalInterest = totalPayment - principal;

  return {
    depositAmount,
    depositPercent,
    principal,
    monthlyPayment,
    totalPayment,
    totalInterest,
  };
};
